import md5 from "md5"

export const PRIV_KEY = "9184e285ddbdb47ca7910d4a36343cc1a2c08619";
export const PUBLIC_KEY = "09dc438eb911801fb1249a80efbf0bb8";
export const ts = new Date().getTime();
export const hash = md5(ts+PRIV_KEY+PUBLIC_KEY);